export class JtiSimpleCodeList
{
  id: number;
  codeListCode: string;
  code: string;
  lineitem: number;
  name: string;
  value: boolean;
}
